import { RefabricProURL } from "../index";
import { ApiResponse } from "../HttpClient";
import {
  IDesignBrushRequest,
  IDesignStartRequest,
  IDesignSaveToCollection,
  IDesignCleanupRequest,
  IDesignGetDesignRequest,
  IZoomOutRequest,
  ICreateVariationRequest,
  IDesignMagic,
  IStartVideoGeneration,
  IDesignCleanupFlatRequest,
  IMakeStitchesRequest,
  IDesignChangedMagic,
  IStartRefineRequest,
  IStartHandFixRequest,
  ISendToExternalHubRequest,
  ISendToExternalHubDetailRequest,
  ISendToReshootRequest,
  IRetryExternalHubRequest,
  IRetryExternalHubResponse,
  IGetExternalHubLogsRequest,
  IGetExternalHubLogsResponse,
  IExternalHubLogDetailResponse,
  IGetExternalHubLogItemStatusesRequest,
  IGetExternalHubLogItemStatusesResponse,
  IStartTechpackArtisticSketchRequest,
  IStartTechpackArtisticSketchResponse,
  IPoseEditRequest,
  IDenimLaserRequest,
  IDenimLaserResponse,
  IExtractPrintFromPhotoRequest,
  IMakeSeamlessTileRequest,
  IExtractPrintFromPhotoResponse,
  IUpscaleImageRequest,
  IUpscaleImageResponse,
  IConvertToSvgResponse,
} from "./design.type";

export default {
  async getDesigns(params: IDesignGetDesignRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`designs/`, { params });
  },
  async getDesignHistoryList(params: IDesignGetDesignRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`designs/history`, { params });
  },
  async getDesign(design_id: string): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`designs/${design_id}`, {});
  },
  async startDesign(data: IDesignStartRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start", data, {});
  },
  async deleteImage(design_id: string, image_id: string): Promise<ApiResponse<any>> {
    return await RefabricProURL.delete(`designs/${design_id}/${image_id}`, {});
  },
  async getDesignStatus(design_id: string): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`designs/status/${design_id}`, {});
  },
  async getDesignStatusError(design_id: string): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`designs/status_error/${design_id}`, {});
  },
  async getDesignHistory(design_id: string): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`designs/${design_id}/history`, {});
  },
  async useBrush(design_id: string, image_id: string, data: IDesignBrushRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/brush`, data, {});
  },
  async useLasso(design_id: string, image_id: string, data: IDesignBrushRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/lasso`, data, {});
  },
  async useCleanup(design_id: string, image_id: string, data: IDesignCleanupRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/cleanup`, data, {});
  },
  async saveToCollection(design_id: string, image_id: string, data: IDesignSaveToCollection): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/add_collection`, data, {});
  },
  async createVariation(design_id: string, image_id: string, data: ICreateVariationRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/create-variation`, data, {});
  },
  async zoomOut(design_id: string, image_id: string, data: IZoomOutRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/zoom-out`, data, {});
  },
  async magic(design_id: string, image_id: string, data: IDesignMagic): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/magic`, data, {});
  },
  async startRefine(data: IStartRefineRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start_refine", data, {});
  },
  async startFlats(data: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start_flats", data, {});
  },
  async startGetCutout(data: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start_get_cutout", data, {});
  },
  async startBackview(data: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start_backview", data, {});
  },
  async startVideoGeneration(data: IStartVideoGeneration): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start_video_generation_seedance", data, {});
  },
  async makeStitches(data: IMakeStitchesRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start_make_stitches", data, {});
  },
  async cleanupFlat(design_id: string, image_id: string, data: IDesignCleanupFlatRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/cleanup_flat`, data, {});
  },
  async changedMagic(design_id: string, image_id: string, data: IDesignChangedMagic): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/changed_magic`, data, {});
  },
  /**
   * `productByUrl` is `{image_url: product_id}` — OPTIONAL, and only the studios send it: with
   * it the archive's entries are named `SKU_1.png`, `SKU_2.png`, … per SKU in the order sent
   * (the BE resolves the SKU, which the client does not know). Omitted, the archive is named
   * exactly as before (`001_<cdn object name>`), which is what every other caller gets.
   *
   * It goes in the BODY, not the query string: this endpoint takes up to 150 urls and the query
   * is already carrying all of them.
   *
   * `subTypes` (REF-6450) is OPTIONAL and index-aligned with the urls in `image_urls`: entry `i` is
   * what member `i` WAS (a `StudioImageType` — `tryon`, `ghost`, `pose_edit`, …) and lands in
   * `download_log_items.sub_type`, where the backoffice reads it instead of reconstructing the type
   * from `result_data`. A member the caller cannot type MUST still occupy its slot — pass `""`, which
   * the BE normalises to NULL — or every later member is attributed to the wrong image. The query
   * is omitted entirely when nothing is typed, so callers that don't know sub-types send exactly
   * what they sent before.
   */
  async downloadHighImagesZip(image_urls: string, email: string, name?: string, ids?: string, productByUrl?: Record<string, string>, subTypes?: string[]): Promise<ApiResponse<any>> {
    const namePart = name ? `&name=${encodeURIComponent(name)}` : "";
    // REF-5664: optional `design_ids=…&image_ids=…` query (index-aligned with image_urls) so the BE
    // records the per-image contents of the bulk zip and can trace each image to its generation.
    const idsPart = ids ? `&${ids}` : "";
    const subTypesPart = subTypes?.some((subType) => subType.trim() !== "") ? subTypes.map((subType) => `&sub_types=${encodeURIComponent(subType)}`).join("") : "";
    const body = productByUrl && Object.keys(productByUrl).length > 0 ? { product_by_url: productByUrl } : {};

    return await RefabricProURL.post(`designs/download-high-images-zip?email=${encodeURIComponent(email)}${namePart}&${image_urls}${idsPart}${subTypesPart}`, body);
  },
  async bulkDeleteDesigns(design_ids: string, image_ids: string): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/bulk-delete?design_ids=${design_ids}&image_ids=${image_ids}`, {}, {});
  },
  async startHandFix(data: IStartHandFixRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/start-hand-fix", data, {});
  },
  async changeBackground(
    design_id: string,
    image_id: string,
    data: { prompt: string; image_path: string; action_type: "background_edit" | "background_remove"; design_type: string; background_asset?: string }
  ): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/change-background`, data, {});
  },
  async glam(design_id: string, image_id: string, data: { prompt: string; image_path: string; edit_process: string; action_type: "glam_room"; design_type: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/glam`, data, {});
  },
  async convertToSvg({ input_image }: { input_image: string }): Promise<ApiResponse<IConvertToSvgResponse>> {
    return await RefabricProURL.post(
      `designs/convert-to-svg`,
      {
        set_images: {
          input_image: input_image,
          mask_input: "",
        },
      },
      {}
    );
  },
  async variateDesign(data: { prompt: string; image_path: string; action_type: "variate_design" }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/variate-design`, data, {});
  },
  // "Download as 4K". Hits the dedicated download-4k endpoint (NOT the legacy
  // GPU upscale-image route): already-4K → { already_4k, download_url }; else a
  // crystal-upscaler job whose result arrives over WS (design_type "upscale_image").
  async upscaleImage(data: IUpscaleImageRequest): Promise<ApiResponse<IUpscaleImageResponse>> {
    return await RefabricProURL.post(`designs/download-4k`, data, {});
  },
  async sendToExternalHub(data: ISendToExternalHubRequest | ISendToExternalHubDetailRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/send_to_external_hub", data, {});
  },
  async sendToReshoot(data: ISendToReshootRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/send_to_reshoot", data, {});
  },
  async retryExternalHub(data: IRetryExternalHubRequest): Promise<ApiResponse<IRetryExternalHubResponse>> {
    return await RefabricProURL.post("designs/retry_external_hub", data, {});
  },
  async getExternalHubLogs(params: IGetExternalHubLogsRequest): Promise<ApiResponse<IGetExternalHubLogsResponse>> {
    return await RefabricProURL.get("designs/external_hub_logs", { params });
  },
  async getExternalHubLogDetail(logId: number): Promise<ApiResponse<IExternalHubLogDetailResponse>> {
    return await RefabricProURL.get(`designs/external_hub_logs/${logId}`, {});
  },
  async getExternalHubLogItemStatuses(params: IGetExternalHubLogItemStatusesRequest): Promise<ApiResponse<IGetExternalHubLogItemStatusesResponse>> {
    return await RefabricProURL.get("designs/external_hub_log_item_statuses", { params });
  },
  async startTechpackArtisticSketch(data: IStartTechpackArtisticSketchRequest): Promise<ApiResponse<IStartTechpackArtisticSketchResponse>> {
    return await RefabricProURL.post("designs/start_techpack_artistic_sketch", data, {});
  },
  async poseEdit(design_id: string, image_id: string, data: IPoseEditRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`designs/${design_id}/${image_id}/pose-edit`, data, {});
  },

  async makeSeamlessTile(data: IMakeSeamlessTileRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post("designs/make-seamless-tile", data, {});
  },

  async extractPrintFromPhoto(data: IExtractPrintFromPhotoRequest): Promise<ApiResponse<IExtractPrintFromPhotoResponse>> {
    return await RefabricProURL.post("designs/extract-print-from-photo", data, {});
  },

  // REF-5521: grayscale laser wear-map for the eMark X (single image in, single image out)
  async denimLaser(data: IDenimLaserRequest): Promise<ApiResponse<IDenimLaserResponse>> {
    return await RefabricProURL.post("designs/denim-laser", data, {});
  },
};
